import {createRoot, hydrateRoot} from 'react-dom/client';
import Blog from '../pages/Blog/Blog'
import "../index.css";
import "../pages/Blog/Blog.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<Blog {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <Blog {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).BlogVC = {mount, hydrate, unmount}